<template>
  <div class="a-enrollment-card">
    <div class="enrollment__content">
      <h2 class="enrollment__heading">Enrollment Information</h2>
      <agent-info />
    </div>
    <div class="enrollment__cta-container">
      <a @click="loading = true" class="enrollment__cta-link" :data-iv-value="$route.name" data-iv-cta="benefit_details_btn" :download="`enrollment-book.pdf`" :href="`/pdf/${$route.params.id}`">
      <div v-if="loading" class="dots">
          <loading-dots color="#ffffff"/>
        </div>
        <span :class="{'text': loading}">Benefit Details</span>
      </a>
    </div>
    <iframe v-if="loading" :src="`/pdf/${$route.params.id}`" @load="iframeLoaded($event)" style="opacity: 0; visibility: hidden; position: absolute; left: -10px; top: -10px; width: 0; height: 0;" name="loadingPDF" />
	</div>
</template>
<script>
// import ACta from '@/components/a-cta'
import { mapGetters } from 'vuex'
import AgentInfo from './agentInfo.vue'
import LoadingDots from './loading-dots.vue'
export default {
  data(){
    return {
      loading: false,
      pdfLoading: false
    }
  },
	components: {
    AgentInfo,
    LoadingDots
	},
	computed:{
		...mapGetters({
			proposalId: 'getProposalId'
		})
	},
	methods: {
    iframeLoaded(e){
      this.loading = false
    }
	}
	
}
</script>
<style lang="scss" scoped>
.a-enrollment-card {
	margin-top: 50px;
	background: $white;
	color: $gray;
	display: flex;
	justify-content: space-between;
	max-width: 750px;
  @media(max-width: 800px) {
    display: block;
  }
}

.enrollment {
  &__content {
    padding: 20px 30px;
  }
  &__heading {
    margin-bottom: 10px;
    color: $red;
    font-weight: bold;
    font-size: 1.2em;
  }
  &__cta-container {
    display: flex;
    align-items: center;
    flex: 0 0 210px;
    @media(max-width: 800px) {
      display: block;
      text-align: center;
    }
  }
  &__cta-link {
    position: relative;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    color: #ffffff;
    justify-content: flex-end;
    text-decoration: none;
    background: $red;
    border: none;
    margin: 20px;
    @media(max-width: 800px) {
      display: inline-block;
    }
    span {
      color: #ffffff;
    }
    .text {
      opacity: 0;
    }
  }
}
.dots {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}


</style>
